import { HealthRecord, VaccinationAct } from "@syadem/kairos-citizen-js";
import {
  DiagnosticForPatientBody,
  DiagnosticForPatientBodyPatientConditionsInner,
  DiagnosticForPatientBodyPatientPreventionActsInner,
} from "@syadem/sad-js";
import { healthRecordGenderToProfileGender } from "../utils/profile";

export function buildPatientFromHealthRecord(healthRecord: HealthRecord): DiagnosticForPatientBody {
  return {
    patient: {
      birthdate: healthRecord.birthDate,
      gender: healthRecordGenderToProfileGender(healthRecord.gender),
      area_of_residency: {
        zipcode: healthRecord.zipCode == null ? undefined : healthRecord.zipCode,
      },
      prevention_acts: healthRecord.vaccinationActs.reduce(
        (acc: DiagnosticForPatientBodyPatientPreventionActsInner[], current: VaccinationAct) => [
          ...acc,
          {
            date: current.performedOn,
            prevention_method_id: current.vaccineId,
            booster: Boolean(current.booster),
          },
        ],
        [],
      ),
      conditions: Object.entries(healthRecord.profile as object).reduce(
        (acc: DiagnosticForPatientBodyPatientConditionsInner[], current) => {
          const [id, condition] = current;
          if (condition.value === null || condition.value === false) {
            return acc;
          }
          return [
            ...acc,
            {
              id,
              value: condition.value,
            },
          ];
        },
        [],
      ),
    },
    requested_by_professional: false,
  };
}

export interface PatientProfile {
  [conditionKey: string]:
    | {
        updatedAt: Date;
        value: ConditionValue;
      }
    | undefined;
}

export type ConditionValue = Date | boolean | number | null;
